import * as React from "react"

const SvgPhone = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M19.95 21.286q-3.125 0-6.175-1.363t-5.55-3.862-3.862-5.55T3 4.336q0-.45.3-.75t.75-.3H8.1a.93.93 0 0 1 .625.237.9.9 0 0 1 .325.563l.65 3.5q.05.399-.025.675a1.06 1.06 0 0 1-.275.475l-2.425 2.45q.5.924 1.188 1.787t1.512 1.663a18 18 0 0 0 1.625 1.437q.85.663 1.8 1.213l2.35-2.35a1.4 1.4 0 0 1 .588-.338 1.6 1.6 0 0 1 .712-.062l3.45.7q.35.1.575.362a.88.88 0 0 1 .225.588v4.05q0 .45-.3.75t-.75.3m-13.925-12 1.65-1.65-.425-2.35H5.025q.125 1.024.35 2.025t.65 1.975m8.95 8.95a12.4 12.4 0 0 0 4.025 1v-2.2l-2.35-.475z" />
  </svg>
)
export default SvgPhone
